import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { SaveService } from '@services/save.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
@Component({
  selector: 'app-dmemberedit',
  templateUrl: './dmemberedit.component.html',
  styleUrls: ['./dmemberedit.component.sass']
})
export class DmembereditComponent implements OnInit {

  @Input('member') member: object;
  statusForm: FormGroup;
  component = "";
  application = "";
  response: any = [];
  status = "";
  name = "";
  bio: any = [];
  country_list: any = [];
  country = "";
  country_code = "";
  error: any = { firstName: '', lastName: '', status: '', phone: '', email: '', country: '' };
  constructor(private _formdataService: FormdataService, private router: Router, private _save: SaveService, private _viewService: ViewService, private fb: FormBuilder, private _global: GlobalService, public ngxSmartModalService: NgxSmartModalService) {

    this.statusForm = this.fb.group({
      firstName: [],
      lastName: [],
      countryCode: [],
      phone_dialCode: [],
      phone_no: []
    });
    this.component = this._global.COMPONENTS_SMN;
    this.application = 'member';

    let f = {
      'component': this.component,
      'application': this.application
    };

    this._formdataService.countries(f).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.country_list = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.response=this.member;
    this.country_code = this._global.getVal(this.response, 'countryCode', '');
    this.statusForm.get('countryCode').setValue(this.country_code);
    this.statusForm.get('phone_no').setValue(this._global.getVal(this.response, 'phone.phone.number', ''));
    this.statusForm.get('phone_dialCode').setValue(this._global.getVal(this.response, 'phone.phone.area', ''));

    this.name = this._global.getVal(this.response, 'firstName', '') + "  " + this._global.getVal(this.response, 'lastName', '');
  }
  update() {
    let r = this._global.generateParams(this.statusForm.value, ['phone_dialCode', 'phone_no']);
    let res = this.country_list.find(x => x.value == r['countryCode']);
    this.country = "";
    if (res) {
      this.country = res["name"];
    }

    r['component'] = this.component;
    r['application'] = 'member';
    r['id'] = this.response.id;
    r['country'] = this.country;
    r['status']="active";
    let phone = { "phone": {} };
    phone["phone"]["area"] = this.statusForm.value['phone_dialCode'];
    phone["phone"]["number"] = this.statusForm.value['phone_no']
    r = this._global.paramsRemoveNull(r);
    r['phone'] = JSON.stringify(phone);
    this._save.appUpdate(r).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          location.reload();
          //this.router.navigate(['/my']);
        }else {
         // this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  getDialCode(event) {
    let res = this.country_list.find(x => x.value == event);
    this.country = this._global.getVal(res, "name", '');
    this.country_code = this.statusForm.value["countryCode"];
    let p = {
      'component': this.component,
      'application': this.application,
      'countryCode': this.statusForm.value["countryCode"]
    };
    this._formdataService.common(p, 'dialCode').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.statusForm.get('phone_dialCode').setValue(this._global.getVal(data, 'response.dialCode', ''));

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

}
